module.exports = __webpack_public_path__ + "assets/logo_footer_old1.png";


/*****************
 ** WEBPACK FOOTER
 ** ./assets/logo_footer_old1.png
 ** module id = 224
 ** module chunks = 1
 **/